import { useAccess, useEntities } from '@lindeza/core/hooks';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconDownload, IconRefresh } from '../components/Icons';
import { Sheet } from '../components/ui';
import { dismissInstall, dismissedInstall, isIos, isStandalone, openCount, promptInstall, usePwa } from './pwa';
import './banners.css';

/** "Nova versão disponível, toque para atualizar" (19.4). */
export function UpdateBanner() {
  const ready = usePwa((s) => s.updateReady);
  const apply = usePwa((s) => s.applyUpdate);
  if (!ready || !apply) return null;
  return (
    <button className="banner" style={{ margin: 'var(--space-sm) var(--space-lg)', border: 0, cursor: 'pointer' }} onClick={apply}>
      <IconRefresh />
      <p className="grow" style={{ textAlign: 'left' }}>
        <strong>Nova versão disponível.</strong> Toque para atualizar.
      </p>
    </button>
  );
}

/**
 * Convite para instalar depois do segundo uso e do primeiro atendimento marcado (19.4).
 */
export function InstallBanner() {
  const installEvent = usePwa((s) => s.installEvent);
  const appointments = useEntities('appointment');
  const [hidden, setHidden] = useState(dismissedInstall());
  const [guide, setGuide] = useState(false);
  if (hidden || isStandalone()) return null;
  if (openCount() < 2 || !appointments || appointments.length === 0) return null;
  const ios = isIos();
  if (!installEvent && !ios) return null;
  return (
    <>
      <div className="banner">
        <IconDownload />
        <p className="grow">Instale o Lindeza no celular: abre mais rápido e funciona sem internet.</p>
        <button
          className="btn btn--primary btn--sm"
          onClick={async () => {
            if (ios) setGuide(true);
            else await promptInstall();
          }}
        >
          Instalar
        </button>
        <button
          className="btn btn--ghost btn--sm"
          aria-label="Agora não"
          onClick={() => {
            dismissInstall();
            setHidden(true);
          }}
        >
          Agora não
        </button>
      </div>
      {guide && <IosInstallGuide onClose={() => setGuide(false)} />}
    </>
  );
}

export function IosInstallGuide({ onClose }: { onClose: () => void }) {
  return (
    <Sheet title="Instalar no iPhone" onClose={onClose}>
      <ol className="stack" style={{ paddingLeft: 20, margin: 0 }}>
        <li>
          Abra este endereço no <strong>Safari</strong>.
        </li>
        <li>
          Toque em <strong>Compartilhar</strong> (o quadrado com a seta para cima).
        </li>
        <li>
          Role e toque em <strong>Adicionar à Tela de Início</strong>.
        </li>
        <li>
          Abra o Lindeza pelo ícone novo e entre com o <strong>código</strong> que chega no seu e-mail.
        </li>
      </ol>
      <button className="btn btn--primary btn--block btn--lg" style={{ marginTop: 'var(--space-xl)' }} onClick={onClose}>
        Entendi
      </button>
    </Sheet>
  );
}

/** Bloqueio suave (épico 9.3): ver continua; marcar novo pede assinatura. */
export function AccessBanner() {
  const access = useAccess();
  if (!access) return null;
  if (access.kind === 'trial' && access.daysLeft <= 3) {
    return (
      <div className="banner banner--warn">
        <p className="grow">
          Faltam <strong>{access.daysLeft} {access.daysLeft === 1 ? 'dia' : 'dias'}</strong> do teste grátis.
        </p>
        <Link className="btn btn--primary btn--sm" to="/ajustes/plano">
          Assinar
        </Link>
      </div>
    );
  }
  if (!access.canCreate) {
    // Bloqueio suave (docs/design/pranchas/10): nada some e nada fica vermelho; o caminho para voltar está à mão.
    return (
      <section className="ct-band" aria-label="Seu teste acabou">
        <div className="ct-band-h">
          <b>{access.kind === 'past_due' ? 'O pagamento não caiu' : 'Seu teste acabou'}</b>
          <Link className="btn btn--accent" to="/ajustes/plano">
            Assinar
          </Link>
        </div>
        <p>Sua agenda e suas clientes continuam salvas. Assine para marcar e cobrar de novo.</p>
      </section>
    );
  }
  return null;
}
